export const getStockInfo = () => {
    const stockChange = document.querySelectorAll<HTMLElement>('.js-stock-change');
    const stockQuote = document.querySelectorAll<HTMLElement>('.js-stock-quote');

    if (stockChange.length && stockQuote.length) {
        getInfo(stockChange, stockQuote)
    }
}

const getInfo = (stockChange: NodeListOf<HTMLElement>, stockQuote: NodeListOf<HTMLElement>) => {
    fetch(
        'https://tools.eurolandir.com/tools/pricefeed/xmlirmultiiso5.aspx?companyid=50697',
    )
        .then(response => response.text())
        .then(str => new window.DOMParser().parseFromString(str, 'text/xml'))
        .then(data => xmlToJson(data))
        .then(quotes => quotes.EuroInvestorQuotes.data)
        .then(quote => {
            const change = quote.PctChange['#text'];
            const figure = quote.Quote['#text']

            stockQuote.forEach( (elStock: Element) => {
                elStock.innerHTML = figure;
            })

            stockChange.forEach( (elChange: Element) => {
                elChange.innerHTML = `${change}%`;
                elChange.classList.add(
                    `is-${change > 0 ? 'positive' : 'negative'}`,
                );
            })
            
        })
        .catch(() => console.log('error'))
}

const xmlToJson = (xml:any): any => {
    // Create the return object
    let obj = {};

    if ((xml?.nodeType ?? 0) == 1) {
        // element
        // do attributes
        if (xml.attributes.length > 0) {
            obj['@attributes'] = {};
            for (let j = 0; j < xml.attributes.length; j++) {
                const attribute = xml.attributes.item(j);
                obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
            }
        }
    } else if ((xml?.nodeType ?? 0) == 3) {
        // text
        obj = xml?.nodeValue;
    }

    // do children
    if (xml?.hasChildNodes() ?? false) {
        const children = xml?.childNodes ?? [];
        for (let i = 0; i < children.length; i++) {
            const item = children.item(i);
            const { nodeName } = item;

            if (typeof obj[nodeName] === 'undefined') {
                obj[nodeName] = xmlToJson(item);
            } else {
                if (typeof obj[nodeName].push === 'undefined') {
                    const old = obj[nodeName];
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                }
                obj[nodeName].push(xmlToJson(item));
            }
        }
    }

    return obj;
}